<script setup>
defineProps({
  /** 落在这个条目或分区里的校验错误说明：`{ key, text }`。 */
  notes: { type: Array, default: () => [] },
})
</script>

<template>
  <ul
    v-if="notes.length"
    class="novel-issue-note"
  >
    <li
      v-for="note in notes"
      :key="note.key"
    >
      {{ note.text }}
    </li>
  </ul>
</template>

<style scoped>
.novel-issue-note {
  display: grid;
  gap: var(--drama-space-xs);
  margin: 0;
  padding: 0;
  list-style: none;
  color: var(--drama-color-danger);
  font-size: var(--drama-font-size-sm);
}
</style>
